<template>
  <div id="head">
    <div :style="header">
      <el-button id="logo-icon" :style="eliconexalltrue" circle></el-button>
    </div>
    <br />
    <br />
    <h1 id="title">事件抽取</h1>
    <p>
      事件抽取技术能够从新闻、公告中，利用序列标注等技术抽取出包含信用工具、市场主体、披露时间等的金融领域事件。
    </p>
  </div>
  <Detail/>
</template>

<script>
import Detail from './components/Detail.vue'

export default {
  name: 'App',
  components: {
    Detail
  },
  data() {
    return {
      header: {
        backgroundImage: "url(" + require("./assets/images/header.png") + ")",
        backgroundSize: 'contain',
        height: '418px',
      },
      eliconexalltrue: {
        backgroundImage: "url(" + require("./assets/images/cover2.png") + ")",
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
      }
    }
  }
}
</script>

<style>
@import "./assets/css/style.css";
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#head {
  padding: 60px;
  background-color: #fbfbfb;
}
#header {
  width: 100%%;
}
#logo-icon {
  position:relative;
  top:210px;
  width:240px; 
  height:240px;
  
}
#logo {
  width: 100%;
}
#title{
  padding: 40px;
  font-size: 28px;
  font-weight: bold;
}
</style>